<template>
    <div class="container raw-view">
        <div v-html="block.value" />
    </div>
</template>

<style lang="scss" scoped>
    .form-control {
        min-height: 2.5rem;
    }
</style>
<style>
.raw-view p {
    min-height: 22px;
}
</style>

<script>
export default {
    data: () => ({
        editor: null
    }),
    props: ['block'],
    components: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>
